import { Route, Routes } from 'react-router';
import type { MultiLang } from '../config';
import CreditsMenu from '../credits/block/CreditsMenu';
import IndexTree from '../database/blocks/IndexTree';
import Functions from '../functions';
import MainMenu from './blocks/MainMenu';
import SelectLang from './blocks/SelectLang';
import TwitterTimeline from './lib/TwitterTimeline';

interface Props {
    lang: MultiLang;
}

const LeftColumn = (props: Props) => {
    const { lang } = props;
    return (
        <div className="leftcolumn">
            <div className="block plate">
                <div className="blockContent">
                    <SelectLang lang={lang} />
                </div>
            </div>
            <div className="block plate">
                <div className="blockTitle">{Functions.mlang('[en]Menu[/en][ja]メニュー[/ja]', lang)}</div>
                <div className="blockContent">
                    <MainMenu lang={lang} />
                </div>
            </div>
            <div className="block plate">
                <div className="blockTitle">
                    {Functions.mlang('[en]Site Information[/en][ja]ウェブサイト情報[/ja]', lang)}
                </div>
                <div className="blockContent">
                    <CreditsMenu lang={lang} showAboutUs={false} />
                </div>
            </div>
            <Routes>
                <Route
                    path="/"
                    element={
                        <div className="block plate">
                            <div className="blockTitle">Twitter</div>
                            <div className="blockContent">
                                <TwitterTimeline lang={lang} screenName="DynamicBrainPF" height={600} />
                            </div>
                        </div>
                    }
                />
                <Route
                    path="/database/*"
                    element={
                        <div className="block plate">
                            <div className="blockTitle">
                                {Functions.mlang('[en]Index Tree[/en][ja]インデックスツリー[/ja]', lang)}
                            </div>
                            <div className="blockContent">
                                <IndexTree lang={lang} />
                            </div>
                        </div>
                    }
                />
                <Route path="*" element={null} />
            </Routes>
        </div>
    );
};

export default LeftColumn;
